import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { ConditionKind } from "../../../define/ConditionKind";
import { TaskKind } from "../../../define/TaskKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import DataVariationManage from "../../manager/DataVariationManage";
import NormalGameManager from "../../manager/NormalGameManager";
import investClean from "./investClean";
import { cityItemI, getCityItemAry, getInvestItemAry, getInvestItemMap, investItem, investOpenType } from "./investConst";
import kLineNode from "./kLineNode";
import selectPriceNode from "./selectPriceNode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class investStock extends cc.Component {

    @property({type:cc.Sprite,displayName:"背景图片"})
    bgNode:cc.Node = null;

    @property({type:cc.Node,displayName:"选择节点"})
    selectNode:cc.Node = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Label,displayName:"顶部文本"})
    lb_Top:cc.Label = null;

    @property({type:cc.SpriteFrame,displayName:"背景图片"})
    bgSprite:cc.SpriteFrame[] = [];

    @property({type:cc.Node,displayName:"价格节点"})
    selectPriceNode:cc.Node = null;

    @property({type:cc.Node,displayName:"k线节点"})
    kLineNode:cc.Node = null;

    @property({type:cc.Node,displayName:"胜利节点"})
    cleanNode:cc.Node = null;

    @property(cc.Node)
    coinNode: cc.Node = null;

    private itemAry:investItem[] = [];

    private itemIdAry:string[] = [];

    m_roundsInCome:number[] = [];

    gameManager:NormalGameManager = null;

    refrenshCount:number = 0;

    currentCity:cityItemI = null;
    
    currentSelectItem:investItem = null;

    openType:investOpenType = investOpenType.normal;

    driftBottleObjID:number = null;

    start(){
        // O1HD.getManagers().soundMgr.playMusic("1");
        this.gameManager = NormalGameManager._instance;
        this.selectNode.active = true;
        this.itemContent.children.forEach((n:cc.Node,index:number)=>{
            n.on("touchstart",this.onBtnTouchStart,this);
            n.on("touchend",(e)=>{
                this.onBtnTouchEnd(e,index);
            },this);
            n.on("touchcancel",this.onBtnTouchCancel,this);
        });

        this.loadInvest();
        this.loadItems();
        
        DataVariationManage.instance.updateData(ConditionKind.ConditionsType.OPEN_WATER_RUN);
    }

    loadInvest(){
        let citys = getCityItemAry();
        let weightAry:number[] = [];
        for(let i = 0;i<citys.length;i++){
            let city = citys[i];
            let weight = city.weight;
            weightAry.push(weight);
        }
        let randIndex:number = data_control.getRandIPosByWeights(weightAry);
        let randCity = citys[randIndex];
        this.currentCity = randCity;
        let data = this.gameManager.getGameData().futuresFuturePrize;
        if(data && this.gameManager.getCurrentDay() == data.triggerDay){
            this.openType = investOpenType.driftBottle;
            this.driftBottleObjID = data.triggerGoodsId;
        }

        let explain:string = randCity.explain;
        this.lb_Top.string = explain;

        getOneBundleByInstant(BUNDLE_SMALL_NAME.investStockGameBundle).load(`assets/bg/${this.currentCity.bgSpPath}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"加载图片失败");
                return;
            }
            this.bgNode.getComponent(cc.Sprite).spriteFrame = spr;
        });

        //TODO 城市已经加载完成 开始播放音效这些

    }

    loadItems(){
        let city = this.currentCity;
        let cityItems = data_control.randomSortArray(city.items.concat());
        let randAry = cityItems.shift();
        let ariseAry:string[] = NormalGameManager._instance.getGameData().investToDayAriseAry;
        while(cityItems.length >0 && ariseAry.includes(randAry.toString())){
            randAry = cityItems.shift();
        }

        if(ariseAry.includes(randAry.toString())){
            let allItems = getInvestItemAry();
            let ary = data_control.randomSortArray(allItems.concat());
            let oneItem = ary.pop().id;
            let twoItem = ary.pop().id;
            let isTrue:boolean = false;
            while(!isTrue){
                let aIsTrue = true;
                for(let i = 0;i<ariseAry.length;i++){
                    let ariseA = ariseAry[i];
                    if(ariseA.includes(oneItem) && ariseA.includes(twoItem)){
                        aIsTrue = false;
                    }
                }
                isTrue = aIsTrue;
            }
            randAry[0] = oneItem;
            randAry[1] = twoItem;
        }

        this.itemIdAry = randAry.concat();

        let ary:investItem[] = [];
        for(let i = 0;i<randAry.length;i++){
            let item = getInvestItemMap()[randAry[i]];
            ary.push(item);
        }
        this.itemAry = ary.concat();
        this.itemContent.children.forEach((n:cc.Node,index:number)=>{
            let nameLb:cc.Label = n.getChildByName("lbName").getComponent(cc.Label);
            let item = ary[index];
            nameLb.string = item.name;
            let sprite:cc.Sprite = n.getChildByName("sp").getComponent(cc.Sprite);
            let spPath:string = item.icon;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.investStockGameBundle).load(`assets/obj/${spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.debug("#加载investStock模式的物品图片失败",err);
                    return;
                }
                sprite.spriteFrame = asset;
            });
        });
    }

    onBtnTouchStart(e:cc.Event.EventTouch){
        this.nodeToScale(e,true);
    }

    onBtnTouchEnd(e:cc.Event.EventTouch,index:number){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.nodeToScale(e,false);
        let item = this.itemAry[index];
        this.currentSelectItem = item;
        this.oneCopyMoney = Math.floor(data_control.getRandNumberOfArrayTwo(item.price));
        this.startPrice(true);
        let ariseAry:string[] = NormalGameManager._instance.getGameData().investToDayAriseAry;
        ariseAry.push(this.itemIdAry.toString());
        NormalGameManager._instance.setGameData({investToDayAriseAry:ariseAry});
    }

    onBtnTouchCancel(e:cc.Event.EventTouch){
        this.nodeToScale(e,false);
    }

    nodeToScale(touch:cc.Event.EventTouch,isActive:boolean){
        let tNode:cc.Node = touch.target;
        let targetNode:cc.Node = tNode.getChildByName("light");
        targetNode.active = isActive;
    }


    onBtnRefrenshStock(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.refrenshCount ++;
            this.loadItems();
        },()=>{

        },null,"投资模式中看视频刷新投资物品");
    }

    //投资的钱
    investMoney:number = 0;

    //当前买的份数
    currentCount:number = 0;

    //每份的钱
    oneCopyMoney:number = 0;

    async onSelectMoney(copyCount:number){
        this.currentCount += copyCount;
        this.investMoney += copyCount * this.oneCopyMoney;
        switch(this.openType){
            case investOpenType.driftBottle:{
                if(this.currentSelectItem.id == this.driftBottleObjID.toString()){
                    this.gameManager.getGameData().futuresFuturePrize = null;
                    this.gameManager.writeGameData();
                }
                break;
            }
        }

        let radio = await this.startKLine();
        this.m_roundsInCome.push(radio);

        let riseMoney:number = this.oneCopyMoney * radio;
        this.oneCopyMoney += riseMoney;

        let inComeType:string = null;
        let rlength = this.m_roundsInCome.length;
        if(rlength > 1){
            let r0 = this.m_roundsInCome[rlength - 2];
            let r1 = this.m_roundsInCome[rlength - 1];
            if(r0 < 0 && r1 <0){
                inComeType = "持续大跌";
            }else if(r0>0 && r1 >0){
                inComeType = "持续大涨";
            }else if(r1 == 0){
                inComeType = "没有变化";
            }else if(r1 < 0){
                inComeType = "大跌";
            }else if(r1>0){
                inComeType = "大涨";
            }
        }
        let judge = this.m_roundsInCome.length > 1 ? inComeType : this.m_roundsInCome[0] == 0 ? "没有变化" : this.m_roundsInCome[0] < 0 ? "大跌" : "大涨";
        if ( judge == "大跌" ) {
            O1HD.getManagers().soundMgr.playSound("investDown").then();
        }else if ( judge == "大涨") {
            O1HD.getManagers().soundMgr.playSound("investUp").then();
        }

        let explain:string = `${this.currentSelectItem.name}${this.m_roundsInCome.length > 1 ? inComeType : this.m_roundsInCome[0] == 0 ? "没有变化" : this.m_roundsInCome[0] < 0 ? "大跌" : "大涨"}，你选择`
        let ks = this.kLineNode.getComponent(kLineNode);
        await ks.updateExplain(explain);
        if(this.oneCopyMoney < 0){
            // 全部亏完
            this.oneCopyMoney = 0;
            this.showWin();
        }
    }

    startPrice(isFirst:boolean = false){
        this.selectPriceNode.getComponent(selectPriceNode).bindData(this,this.onSelectMoney.bind(this),isFirst?this.currentSelectItem.oneCount:this.currentSelectItem.followCount);
        this.selectPriceNode.active = true;
    }

    startKLine(){
        return new Promise<number>(async resolve=>{
            this.kLineNode.active = true;
            let ks = this.kLineNode.getComponent(kLineNode);
            ks.bindData(this);
            ks.loadStroke()
            let radio = await ks.startStorke();
            resolve(radio);
        });
    }

    onSell(){
        this.showWin();
    }

    showWin(){
        let ws = this.cleanNode.getComponent(investClean);
        ws.bindData(this);
        this.cleanNode.active = true;
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }
}
